import HTTP from "../../http";

const USERS_ENDPOINT = "/users";
const PROFILE_ENDPOINT = "/profile";

export async function profile() {
  return await HTTP.get(USERS_ENDPOINT + PROFILE_ENDPOINT);
}
